import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-relatorio-log',
  templateUrl: './relatorio-log.component.html',
  styleUrls: ['./relatorio-log.component.css']
})
export class RelatorioLogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
